import { getEnv } from 'utils/env';

export const ULA_URL = 'ULA_URL';
export const ulaUrl = getEnv('ULA_URL');
